import React, { Component } from "react";
import FlexView from "react-flexview";
import ModalContainer from "../../../../../modules/commons/ModalContainer";
import SimpleButton from "../../../../../modules/commons/SimpleButton";
import SimpleModal from "../../../../../modules/popup/SimpleModal";
import SimpleDataTable from "../../../../../modules/SimpleDataTable";
import SimpleInput from "../../../../../modules/SimpleInput";
import Api from "../../../../../Services/Api";
import { fetchDataAsync } from "../../../../../Services/Utils";
import { HttpStatus, INITIAL_PAGINATION } from "../../../../common/Constants";
import { modalBookingTableConfig } from "./config";
import { defaultTableChange } from "../../../../../modules/custom/customTable";

class ModalBooking extends Component {
  constructor(props) {
    super(props);
    this.state = {
      dataTable: [],
      searchValue: "",
      pagination: INITIAL_PAGINATION,
    };
  }

  componentDidMount() {
    this.fetchData();
  }

  componentDidUpdate(prevProps, prevState) {
    const currPagination = this.state.pagination;
    const prevPagination = prevState.pagination;
    if (
      currPagination.page !== prevPagination.page ||
      currPagination.limit !== prevPagination.limit
    ) {
      this.fetchData();
    }
  }

  handleSelectBooking = (data) => {
    const { onChangeData, onClickClose } = this.props;
    onChangeData("noBooking", data);
    onClickClose();
  };

  fetchData = async () => {
    const { onTriggerLoading, formData } = this.props;
    const { searchValue } = this.state;

    onTriggerLoading();
    const res = await fetchDataAsync({
      asyncFn: Api.create("NAGAMAS_TRANSACTION").getFjbBookingNo,
      setError: this.props.setError,
      menuName: "Faktur Jual - Data Unit",
      args: {
        customerName: searchValue,
        kodeCabang: formData?.kodeCabang?.value,
        limit: this.state.pagination.limit,
        page: this.state.pagination.page,
      },
    });
    onTriggerLoading();
    if (res.ok && res.data.status === HttpStatus.SUCCESS) {
      this.setState((prev) => ({
        ...prev,
        dataTable: res.data.data,
        pagination:{
          ...prev.pagination,
          totalData: res.data.totalData
        }
      }));
    }
  };

  getTableConfig = () => {
    return modalBookingTableConfig({
      onSelect: this.handleSelectBooking
    });
  };

  handleChangePage = (tableState) => {
    this.setState((prevValue) => ({
      ...prevValue,
      pagination: {
        ...prevValue.pagination,
        page: tableState.page + 1,
      },
    }));
  };

  handleRowsPerPage = (tableState) => {
    this.setState((prevValue) => ({
      ...prevValue,
      pagination: {
        page: 1,
        totalData: 1,
        limit: tableState.rowsPerPage,
      },
    }));
  };

  render() {
    const { visible, onClickClose } = this.props;
    const { dataTable, pagination, searchValue } = this.state;
    return (
      <React.Fragment>
        <SimpleModal
          title="List Data Booking"
          visible={visible}
          onClickClose={onClickClose}
          content={
            <ModalContainer>
              <FlexView vAlignContent="center">
                <h4 className="txt-site txt-11 txt-main txt-bold margin-bottom-20px">
                  Nama Konsumen
                </h4>
                <SimpleInput
                  id="consumenName"
                  name="searchValue"
                  value={searchValue}
                  onChange={({ target }) =>
                    this.setState({
                      searchValue: target.value,
                    })
                  }
                  placeholder="Nama Konsumen"
                  containerclassname="width width-250px margin-left-10px"
                />
                <SimpleButton
                  id="btn_consumen_name"
                  className="margin-bottom-20px"
                  text="Cari"
                  onClick={() => this.fetchData()}
                />
              </FlexView>
              <SimpleDataTable
                data={dataTable}
                columns={this.getTableConfig()}
                toCount={pagination.totalData}
                rowsPerPage={pagination.limit}
                page={pagination.page - 1}
                options={defaultTableChange(
                  this.handleChangePage,
                  this.handleRowsPerPage
                )}
              />
            </ModalContainer>
          }
        />
      </React.Fragment>
    );
  }
}

export default ModalBooking;
